import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Collapse, Divider, Stack, TextField, Typography } from '@mui/material';

import { ResidentCareFormValues } from 'src/hooks/forms/useResidentCareTaskForm';
import { CareProvided as CareTaskCategory } from 'src/store/sageAdminApi';

interface UnplannedCareNoteFieldProps {
    categoryId: CareTaskCategory;
}

const UnplannedCareNoteField = ({ categoryId }: UnplannedCareNoteFieldProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { register } = useFormContext<ResidentCareFormValues>();

    return (
        <>
            <Divider />
            <Box onClick={(e) => e.stopPropagation()} sx={{ p: 2 }}>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center', minHeight: 40 }}
                >
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Note
                    </Typography>
                    {!isExpanded && (
                        <Button
                            variant="text"
                            startIcon={<FontAwesomeIcon icon={faPlus} />}
                            onClick={() => setIsExpanded(true)}
                            size="extraSmall"
                            sx={{ p: 0 }}
                        >
                            Add note
                        </Button>
                    )}
                </Stack>
                <Collapse in={isExpanded}>
                    <TextField
                        {...register(`unplannedCare.${categoryId}.note` as any)}
                        placeholder="Add note here"
                        multiline
                        minRows={2}
                        fullWidth
                        variant="outlined"
                        sx={{
                            mt: 1,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 3,
                            },
                        }}
                    />
                </Collapse>
            </Box>
        </>
    );
};

export default UnplannedCareNoteField;
